import React from "react";

const PageTitle = ({ children }) => {
    return (
        <h1 className="text-xl sm:text-2xl font-bold leading-tight tracking-tight text-gray-900 mb-1">{children}</h1>
    )
}

export default PageTitle;